<template>
  <div>
    <el-button type="primary" @click="handleAdd">新增目录</el-button>
    <!-- 目录列表 -->
    <el-table v-loading="loading" :data="dirs">
      <el-table-column label="标题" prop="name" :show-overflow-tooltip="true" width="300" />
      <el-table-column label="文档数量" prop="docCount" :show-overflow-tooltip="true" width="150" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="scope.row.name!='/'"

            @click="handleUpdate(scope.row)"
          >
          <svg t="1761296539009" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5544" width="16" height="16"><path d="M384.659 571.632l70.172 70.036-93.508 23.304zM936.493 129.167l-35.479-35.412c-9.771-9.789-25.709-9.789-35.448 0L678.381 280.829l46.764 46.699-46.799-46.701-283.74 283.315 70.923 70.805 283.769-283.305 0.006 0.008 187.189-187.089c9.773-9.772 9.773-25.639 0-35.394z" fill="#1296db" p-id="5545"></path><path d="M139.853 940.403c-29.676 0-53.818-24.155-53.818-53.848V205.064c0-29.676 24.143-53.818 53.818-53.818h590.182L622.396 258.88H193.723v573.886h573.832V406.3l107.638-107.675v587.931c0 29.692-24.142 53.848-53.817 53.848H139.853z" fill="#1296db" p-id="5546"></path></svg>
          修改</el-button>
          <el-button
            size="mini"
            type="text"
            v-if="scope.row.name!='/'"
            @click="handleDelete(scope.row)"
          >
          <svg t="1761296646780" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6708" width="16" height="16"><path d="M256 298.666667h512v554.666666H256V298.666667z m85.333333 85.333333v384h341.333334V384H341.333333z m42.666667 85.333333h85.333333v213.333334H384v-213.333334z m170.666667 0h85.333333v213.333334h-85.333333v-213.333334zM213.333333 298.666667h597.333334v85.333333H213.333333V298.666667z m170.666667-128h256v85.333333H384V170.666667z" fill="#1296db" p-id="6709"></path></svg>
          删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="350px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <input type="hidden" v-model="form.id">
        <el-row :gutter="10" class="mb8">
          <el-col :span="24">
            <el-form-item label="目录名称" prop="name">
              <el-input v-model="form.name" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addFolder, updateFolder, deleteFolder, listDirsByTenantid } from "@/api/aics/KbDocument.js";

export default {
  name: "AnythingllmDirManage",

  props: {
    tenantId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      title: "",
      open: false,
      dirs: [],
      form: {
        id: 0,
        old_name: "",
        name: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入目录名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.refresh_table();
  },
  methods: {
    refresh_table() {
      this.loading = true;
      listDirsByTenantid(this.tenantId).then(response => {
        console.log("目录列表:", response);
        if (response.data.code === 200) {
          this.dirs = response.data.data;
          console.log("目录列表:", this.dirs);
        } else {
          this.$message.error(response.message || "获取目录列表失败");
        }
      }).catch(error => {
        console.error("获取目录列表失败:", error);
        this.loading = false;
      });
      this.loading = false;
    },
    handleAdd: function() {
      this.form.name = "";
      this.form.old_name = "";
      this.open = true;
      this.title = '新增目录';
    },
    handleUpdate: function(row) {
      console.log(row)
      this.form.old_name = row.name;
      this.form.name = row.name;
      this.form.id = row.id;
      this.open = true;
      this.title = '重命名目录';
    },
    /** 提交按钮 */
    submitForm: function() {
      console.log(this.form)
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.form.old_name !== "") {
            if (this.form.name === this.form.old_name) {
              this.$message.error("目录名称未修改");
              this.loading = false;
              return;
            }

            updateFolder(this.form.id, this.tenantId, this.form.name).then(response => {
              console.log("updateFolder",response)
              if (response.data.code === 200) {
                this.$message.success("修改成功");
                this.open = false;
              } else {
                this.$message.error(response.data.message || "修改失败");
              }
              this.refresh_table();
              this.loading = false;
            }).catch(error => {
              console.error("修改失败:", error);
              this.loading = false;
            });
          } else {
            addFolder(this.tenantId, this.form.name).then(response => {
              console.log(response)
              if (response.data.code === 200) {
                this.$message.success("新增成功");
                this.open = false;
              } else {
                this.$message.error(response.data.message || "新增失败");
              }
              this.refresh_table();
            }).catch(error => {
              console.error("新增失败:", error);
              this.loading = false;
            });
          }
        }
      });
    },
    cancel() {
      this.open = false;
    },
    handleDelete: function(row) {
      console.log(row)
      if(row.docCount>0){
        this.$message.error("该目录包含文档，不能删除");
        return;
      }
      this.$confirm("确认删除该目录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading = true;
        deleteFolder(row.id).then(response => {
          console.log("deleteFolder",response)
          if (response.data.code === 200) {
           this.$message.success("删除成功");

          } else {
            this.$message.error(response.data.message || "删除失败");
          }
          this.refresh_table();
          this.loading = false;
        }).catch(error => {
          console.error("删除失败:", error);
          this.loading = false;
        });
      }).catch(() => {
        this.loading = false;
      });
    }
  }
}
</script>